import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Box,
  Grid,
  Paper,
  Button,
  Typography,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import moment from "moment";
import { getUserArticleOrders } from "../../../../redux-store/articles/actions";
import { Pagination } from "@mui/material"; // Import Pagination

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "5px",
    marginTop: "30px",
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  },
  tabHeading: {
    fontSize: "32px",
    fontWeight: 550,
    margin: "0",
  },
  paper: {
    height: "200px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: 5,
    textAlign: "center",
  },
  title: {
    margin: 0,
    fontWeight: 500,
    flex: "1 0 auto",
  },
  date: {
    margin: 0,
    flex: "1 0 auto",
  },
  buttonBox: {
    textAlign: "right",
    marginTop: "auto",
  },
}));

function Articles() {
  const history = useHistory();
  const classes = useStyles();
  const { currentUser } = useSelector((state) => state.auth);
  const { articles = [], loading, error } = useSelector(
    (state) => state.customerArticles
  );
  const [currentPage, setCurrentPage] = useState(1);
  const articlesPerPage = 6; // Number of articles per page
  const dispatch = useDispatch();

  useEffect(() => {
    if (currentUser && currentUser._id) {
      dispatch(getUserArticleOrders(currentUser._id));
    }
  }, [dispatch, currentUser]);

  // Get current articles
  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = articles.slice(indexOfFirstArticle, indexOfLastArticle);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <div className={classes.root}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <h2 className={classes.tabHeading}>My Articles</h2>
      </Box>
      {loading ? (
        <Grid container spacing={3}>
          {[...Array(articlesPerPage)].map((_, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <Paper elevation={2} className={classes.paper}>
                <Skeleton variant="text" width="80%" height={30} />
                <Skeleton variant="text" width="60%" height={20} />
                <Skeleton variant="rect" width="100%" height={118} />
              </Paper>
            </Grid>
          ))}
        </Grid>
      ) : articles.length > 0 ? (
        <>
          <Grid container spacing={3}>
            {currentArticles.map((article) => (
              <Grid item xs={12} md={6} lg={4} key={article._id}>
                <Paper elevation={2} className={classes.paper}>
                  <Typography variant="h6" className={classes.title}>
                    {article?.article?.article_title}
                  </Typography>
                  <Typography variant="body2" className={classes.date}>
                    {moment(article.date_updated).format("MMM Do YYYY, h:mm a")}
                  </Typography>
                  <Box className={classes.buttonBox}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => {
                        history.push(`/article/${article.article._id}/read`);
                      }}
                    >
                      Read Now
                    </Button>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
          {articles.length > articlesPerPage && (
            <Box display="flex" justifyContent="center" mt={4}>
              <Pagination
                count={Math.ceil(articles.length / articlesPerPage)}
                page={currentPage}
                onChange={handlePageChange}
                sx={{
                  "& .MuiPaginationItem-root": {
                    "&:hover": {
                      backgroundColor: "#FECE00",
                    },
                  },
                  "& .Mui-selected": {
                    backgroundColor: "#FECE00",
                    color: "#000",
                  },
                  "& .MuiPaginationItem-ellipsis": {
                    color: "#FECE00",
                  },
                }}
              />
            </Box>
          )}
        </>
      ) : (
        <Box>
          <Typography
            variant="h2"
            color="error"
            style={{ margin: "30px auto" }}
          >
            No Articles bought yet.
          </Typography>
        </Box>
      )}
    </div>
  );
}

export default Articles;
